import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as CrossIcon } from "../../../assets/images/crossIcon.svg";
import CustomDrawer from "../../UniversalComponents/CustomDrawer";
import { usePostOptionDeleteMutation, usePostViewDeleteMutation } from "../../../utils/customer/customerListHeader";
import { getCompanyId } from "../../../utils/utilityFunctions/localServices";
import { pushAlert } from "../../../utils/alertSlice";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import ConfirmationDialog from "../../UniversalComponents/ConfirmationDialogMulti";
import Button from "../../UniversalComponents/DefaultButton";
import { getTitleCase } from "../../../utils/utilityFunctions/stringUtility";
import { ReactComponent as EyeIcon } from "../../../assets/images/eyes.svg";
import { ReactComponent as HiddenEyeIcon } from "../../../assets/images/hiddeneyes.svg";

const ManageFieldDrawer = ({
  headerConfig,
  isOpen,
  close,
  view,
  handleChangeView,
  listViewData,
  handleFieldVisibility,
  refetchHeader,
  setNewViewName,
  handleReorderFields,
  fetchFieldOptions,
  handleSave = () => {},
}) => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [headerConfigData, setHeaderConfigData] = useState([]);

  const dispatch = useDispatch();

  const [viewToDelete, setViewToDelete] = useState(null);
  const [showConfirmationBox, setShowConfirmationBox] = useState(false);
  const [isColumnReordered, setIsColumnReordered] = useState(false);
  const [confirmationText, setConfirmationText] = useState("Are you sure want to discard this draft ?");

  console.log("laoaoa", listViewData, headerConfig);

  const [
    postViewDelete,
    {
      data: postViewDeleteResponse,
      isSuccess: isViewDeleteSuccess,
      isError: isViewDeleteError,
      isLoading: isViewDeleteLoading,
    },
  ] = usePostViewDeleteMutation();

  useEffect(() => {
    //loading
    if (isViewDeleteLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (isViewDeleteSuccess) {
      dispatch(
        pushAlert({
          message: postViewDeleteResponse.message,
          type: postViewDeleteResponse.success ? "success" : "danger",
          visible: true,
        })
      );
      if (postViewDeleteResponse?.success) {
        if (view.view_name === viewToDelete?.view_name) {
          setNewViewName("Default");
          handleChangeView("Default");
        } else {
          refetchHeader();
        }
        setViewToDelete(null);
      }
    }
    // catch block
    if (isViewDeleteError) {
      dispatch(pushAlert({ message: postViewDeleteResponse?.message, type: "danger", visible: true }));
    }
  }, [isViewDeleteSuccess, isViewDeleteError, isViewDeleteLoading]);

  useEffect(() => {
    setHeaderConfigData(headerConfig);
  }, [headerConfig]);

  const handleDragStart = (headerItem, index) => {
    setDraggedItem({ headerItem, index });
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  const handleDrop = (status, targetIndex) => {
    handleReorderFields(draggedItem.index, targetIndex);
    if (draggedItem.index !== targetIndex) setIsColumnReordered(true);
  };

  const HandleConfirmationBox = () => {
    if (isColumnReordered) {
      setConfirmationText("Do you want to discard changes?");
      setShowConfirmationBox(true);
    } else close(false);
  };

  const handleDeleteView = () => {
    postViewDelete({
      payload: {
        view_name: viewToDelete?.view_name,
        company_id: getCompanyId(),
        type: viewToDelete?.view_access ? "public" : "private",
      },
    });
  };

  const handleConfirmClick = () => {
    if (viewToDelete) {
      handleDeleteView(viewToDelete);
    } else close(false);
    setShowConfirmationBox(false);
    setConfirmationText("");
  };

  const [optionsDelete] = usePostOptionDeleteMutation();

  const handleDeleteOption = (choice, fieldName) => {
    if (!choice?.id) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Invalid option ID",
          type: "danger",
        })
      );
      return;
    }

    const payload = {
      id: choice.id,
      company_id: getCompanyId(),
    };

    optionsDelete({ payload })
      .unwrap()
      .then((result) => {
        if (result?.success) {
          dispatch(
            pushAlert({
              visible: true,
              message: result.message || "Option deleted successfully",
              type: "success",
            })
          );
          fetchFieldOptions(fieldName);
        } else {
          dispatch(
            pushAlert({
              visible: true,
              message: result.message || "Failed to delete option",
              type: "danger",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          pushAlert({
            visible: true,
            message: error?.data?.message || "Something went wrong while deleting option",
            type: "danger",
          })
        );
      });
  };
  //  EyeIcon
  return (
    <CustomDrawer open={isOpen} onClose={() => close(false)}>
      <div className=" h-full flex flex-col justify-between ">
        <div className="flex items-center justify-between py-4 px-6 border-b-[1px] border-[#E5E7EB] ">
          <h3 className="text-20 font-bold text-[#131313CC]">Manage Fields</h3>
          <div className="flex items-center gap-4">
            <span className="float-right text-20 cursor-pointer" onClick={HandleConfirmationBox}>
              <CrossIcon className="w-3 h-3" />
            </span>
          </div>
        </div>

        <div className="p-4 w-100 bg-white h-full flex flex-col min-h-0">
          {listViewData?.visible_fields && (
            <div className="flex flex-col items-start gap-2 min-h-0 grow">
              {/* Header */}
              <div className="flex gap-3 items-center shrink-0">
                <span className="w-7 h-7 rounded-full bg-[#DBEAFE] flex justify-center items-center">
                  <EyeIcon className="w-4 h-4" />
                </span>
                <h4 className="text-[#131313CC] font-poppins font-bold text-14">Visible Fields</h4>
                <span className="w-7 h-7 rounded-full bg-[#DBEAFE] flex justify-center items-center">
                  <p className="text-xs text-[#155DFC] font-normal">{listViewData.visible_fields.length}</p>
                </span>
              </div>

              {/* List */}
              <div className="w-full min-h-0 grow overflow-y-auto thinscrollbar pr-2">
                {listViewData.visible_fields.map((field, index) => (
                  <div
                    key={index}
                    className={`w-full border px-4 py-3 border-[#E5E7EB] group cursor-pointer bg-[#FFFFFF] hover:bg-[#004EFF0D]/5 rounded-xl flex justify-between items-center my-2 ${
                      dragOverIndex === index ? "bg-gray-200" : ""
                    }`}
                    draggable
                    onDragStart={() => handleDragStart(field, index)}
                    onDragOver={(e) => handleDragOver(e, index)}
                    onDragLeave={handleDragLeave}
                    onDrop={(e) => handleDrop(true, index)}
                  >
                    <div className="flex items-center gap-1">
                      <button className="cursor-grab">
                        <i className="bi bi-grip-vertical mr-2 text-CCD4DC hover:text-667279"></i>
                      </button>

                      <div className="mr-2">
                        <input
                          type="checkbox"
                          className="peer appearance-none w-4 h-4 border border-gray-400 rounded-sm
                  checked:bg-[var(--color-primary)] checked:border-[var(--color-primary)]
                  focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:ring-offset-1
                  cursor-pointer"
                          id={`checkbox-${index}`}
                          checked
                          onChange={() => handleFieldVisibility(field)}
                        />
                        <label htmlFor={`checkbox-${index}`} className="bottom-[15px]"></label>
                      </div>

                      <span className="checkbox-label capitalize">
                        {headerConfigData?.find((item) => item.value === field)?.label}
                        <span className="text-xs text-primary bg-primary-hover group-hover:bg-primary-15 px-2 ms-2 rounded">
                          {getTitleCase(headerConfigData?.find((item) => item.value === field)?.type || "null")}
                        </span>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {listViewData?.hidden_fields && (
            <div className="flex flex-col items-start gap-2 flex-none max-h-[50%] min-h-0 py-2">
              {/* Header */}
              <div className="flex gap-3 items-center shrink-0">
                <span className="w-7 h-7 rounded-full bg-[#F3F4F6] flex justify-center items-center">
                  <HiddenEyeIcon className="w-4 h-4" />
                </span>
                <h4 className="text-[#131313CC] font-poppins font-bold text-14">Hidden Fields</h4>
                <span className="w-7 h-7 rounded-full bg-[#F3F4F6] flex justify-center items-center">
                  <p className="text-xs text-[#4A5565] font-normal">{listViewData.hidden_fields.length}</p>
                </span>
              </div>

              {/* List */}
              <div className="w-full min-h-0 overflow-y-auto thinscrollbar pr-2">
                {listViewData.hidden_fields.map((field, index) => (
                  <div
                    key={index}
                    className="w-full border px-4 py-3 cursor-pointer border-[#E5E7EB] bg-[#FFFFFF] opacity-60 rounded-xl flex justify-between items-center my-2 group"
                  >
                    <div className="flex items-center gap-1">
                      <button className="cursor-default">
                        <i className="bi bi-grip-vertical mr-2 text-CCD4DC"></i>
                      </button>

                      <div className="mr-2">
                        <input
                          type="checkbox"
                          className="focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] focus:ring-offset-1 cursor-pointer"
                          id={`checkboxHidden-${index}`}
                          checked={false}
                          onChange={() => handleFieldVisibility(field)}
                        />
                        <label htmlFor={`checkboxHidden-${index}`} className="bottom-[15px]"></label>
                      </div>

                      <span className="checkbox-label capitalize text-[#888888]">
                        {headerConfigData?.find((item) => item.value === field)?.label}
                        <span className="text-xs text-primary bg-primary-active px-2 ms-2 rounded">
                          {getTitleCase(headerConfigData?.find((item) => item.value === field)?.type)}
                        </span>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="border-t-2 w-full bg-white">
          <div className="flex justify-end space-x-4 m-5">
            {true && (
              <Button variant={"primary"} onClick={() => handleSave()}>
                Apply
              </Button>
            )}
          </div>
        </div>
      </div>
      {showConfirmationBox && (
        <ConfirmationDialog
          open={showConfirmationBox}
          onConfirm={() => handleConfirmClick()}
          onClose={() => setShowConfirmationBox(false)}
          title={viewToDelete?.view_name ? "Delete View Confirmation" : "Discard?"}
          message={confirmationText}
          confirmVariant={viewToDelete?.view_name ? "delete" : "discard"}
          confirmText={viewToDelete?.view_name ? "Delete" : "Yes"}
          cancelText={viewToDelete?.view_name ? "Cancel" : "No"}
          iconVariant={viewToDelete?.view_name ? "delete" : "discard"}
        />
      )}
    </CustomDrawer>
  );
};
export default ManageFieldDrawer;
